/* eslint-disable @next/next/no-img-element */
import React, { FC, useEffect, useState } from 'react';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  Container,
  RevealWrapper,
  CompanyName,
  NextButtonWrapper,
  Logo,
  TextWipeOut,
  LogoWipeIn,
  LetsGoButton,
  IconWrapper,
} from './LaunchScreen.styles';
import { Box } from '@mui/material';
import { useAppDispatch, useTypedSelector } from '../../store/store';
import { getRevealBackground } from './LaunchScreen.helpers';
import { SignUpScreenStrings } from '../../common/localization/en';
import { useTrackEvent } from '../../common/hooks/useTrackEvent';
import { EventNames } from '../../common/constants/constants';
// import { SocialVenuLogo } from '../../common/assets/SocialvLogo';
import { NextIcon } from '../../common/assets/NextIcon';
import { useClientType } from '../../services/hooks/useClientType';
import tinycolor from 'tinycolor2';
import { setHideCrispChat } from '../../store/slices/ui';
import { useCrispChat } from '../../services/crisp/useCrispChat';

// const TEXT_PADDING = 40;

interface Props {
  isLoading: boolean;
  setIsLaunchScreen: (isLaunchScreen: boolean) => void;
}

const LaunchScreen: FC<Props> = ({ isLoading, setIsLaunchScreen }) => {
  const dispatch = useAppDispatch();

  const { hideCrispChatToggle, showCrispChat } = useCrispChat();

  useEffect(() => {
    dispatch(setHideCrispChat(true));
    hideCrispChatToggle();
    return () => {
      dispatch(setHideCrispChat(false));
      showCrispChat();
    };
  }, []);

  const {
    account: { logo, name },
    accountAttributes: { properties },
  } = useTypedSelector((state) => state.account);

  const reveal = properties?.['webapp.launch-screen']?.reveal;
  // const type = properties?.['webapp.launch-screen']?.type;

  const brandColor = properties?.['webapp.config']?.['primary-color'];
  const splashImage = properties?.['webapp.cards-welcome']?.desktop.original;
  const revealValue = reveal ? reveal : splashImage ? 'splash' : 'branding';
  const { isUVMClient } = useClientType();
  const hideBackgroundImages = properties?.['webapp.config']?.hideBackgroundImages;
  const useCustomBranding = properties?.['webapp.branding']?.useCustomBranding;
  const backgroundColorPrimary = properties?.['webapp.branding']?.backgroundColorPrimary;
  const backgroundImage = properties?.['webapp.branding']?.backgroundImagePrimary;

  const customBackground = useCustomBranding ? backgroundImage ? `url(${backgroundImage})` : backgroundColorPrimary ? backgroundColorPrimary : null : null;

  const background = customBackground ? customBackground : isUVMClient ? '#C3E5E4' : hideBackgroundImages ? 'white' : `url(/mattrogers01.jpg)`;
  // const launchType = type ? type : logo ? 'logo' : 'name';




  const letsGoButtonTextColor = tinycolor(brandColor).isDark() ? 'white' : 'black';

  // const coverBackground = getCoverBackground(properties?.['webapp.launch-screen']?.cover, brandColor);
  const revealBackground = getRevealBackground(revealValue, brandColor, splashImage);
  const [isBackgroundImageLoading, setIsBackgroundImageLoading] = useState(true);
  const [showNextButton, setShowNextButton] = useState(false);
  const [textFadeOut, setTextFadeOut] = useState(false);
  const [showSVLogo, setShowSVlogo] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);
  // const [hasMeasured, setHasMeasured] = useState(false);
  const [showText, setShowText] = useState(true);
  const { trackEvent } = useTrackEvent();

  useEffect(() => {
    trackEvent({ action: EventNames.opening_animation_start });
  }, []);

  useEffect(() => {
    setIsLaunchScreen(true);
  }, [setIsLaunchScreen]);

  useEffect(() => {
    if (revealValue !== 'splash' || !splashImage) {
      setIsBackgroundImageLoading(false);
    } else {
      const image = new Image();
      image.src = revealBackground;
      image.onload = () => {
        setTimeout(() => {
          setIsBackgroundImageLoading(false);
        }, 300);
      };
    }
  }, [revealBackground, revealValue, splashImage]);
  useEffect(() => {
    const timer = setTimeout(() => setTextFadeOut(true), 2000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => setShowText(true), 550);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => setShowSVlogo(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let redirectTimer: ReturnType<typeof setTimeout>;

    if (!isLoading && !isBackgroundImageLoading) {
      redirectTimer = setTimeout(() => {
        setShowNextButton(true);
      }, 2000);
    }

    return () => {
      clearTimeout(redirectTimer);
    };
  }, [dispatch, isBackgroundImageLoading, isLoading, setShowNextButton]);

  useEffect(() => {
    const timeout = setTimeout(() => setAnimateIn(true), 100); // slight delay lets browser register the element first
    return () => clearTimeout(timeout);
  }, []);

  // const containerElement = useRef<HTMLDivElement>(null);
  // const textElement = useRef<HTMLParagraphElement>(null);

  // useEffect(() => {
  //   const container = containerElement.current;
  //   const textContainer = textElement.current;
  //   let fontSize = 44;

  //   if (container && textContainer) {
  //     const textNodes = textContainer.children;

  //     for (let i = 0; i < textNodes.length; i++) {
  //       const textNode = textNodes.item(i) as HTMLSpanElement;
  //       let textWidth = textNode.offsetWidth;

  //       while (textWidth >= container.offsetWidth - TEXT_PADDING) {
  //         textContainer.style.fontSize = `${fontSize}px`;
  //         textWidth = textNode.offsetWidth;
  //         --fontSize;
  //       }
  //     }
  //   }
  //   setHasMeasured(true);
  // }, [containerElement, textElement]);

  const handleClick = () => {
    trackEvent({ action: EventNames.opening_animation_end });
    setIsLaunchScreen(false);
  };
  const textColor = hideBackgroundImages ? brandColor : 'white';
  //#C3E5E4
  
  return (
    <>
      <Container
        sx={{
          background: background,
          backgroundPositionX: '10%',
          backgroundSize: '100% 100%',
        }}
        // ref={containerElement}
      >
        {showText && (
          <Box position={'absolute'} top="10%" width="90%">
            
              <TextWipeOut $fadeOut={textFadeOut} style={{ color: textColor }}>
                {SignUpScreenStrings.InspirationText}
              </TextWipeOut>
            
          </Box>
        )}
        {showSVLogo && (
          <LogoWipeIn
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            position="absolute"
            top="10%"
            width="90%"
          >
            {logo ? (
              <Logo src={logo} alt="Company logo" />
            ) : (
              <CompanyName
                sx={{ color: brandColor }}
                style={hideBackgroundImages ? { color: brandColor } : {}}
              >
                {name.split(' ').map((text) => (
                  <span key={text}>{text} </span>
                ))}
              </CompanyName>
            )}
            {/* <SocialVenuLogo /> */}
          </LogoWipeIn>
        )}
        <RevealWrapper
          sx={{
            clipPath:
              isLoading || isBackgroundImageLoading ? 'ellipse(0% 0% at 100% 100%)' : 'ellipse(140% 180% at 100% 100%)',
          }}
        />

        {/* {launchType === 'logo' ? (
          <img src={logo} alt="Company logo" className={styles.logo} />
        ) : (
          <Typography className={styles.companyName} sx={{ color: brandColor }} ref={textElement}>
            {name.split(' ').map((text) => (
              <span key={text}>{text} </span>
            ))}
          </Typography>
        )} */}

        {/* <NextButtonWrapper>
          {!isLoading && !isBackgroundImageLoading && showNextButton && (
            <Button
              className={styles.companyName}
              onClick={handleClick}
              variant="contained"
              sx={{ textShadow: revealValue === 'splash' ? `2px 2px 0px ${brandColor}` : 'unset', color: '#FFF' }}
            >
              {SignUpScreenStrings.LetsGo}
            </Button>
          )}
        </NextButtonWrapper> */}
        <NextButtonWrapper>
          {!isLoading && !isBackgroundImageLoading && showNextButton && (
            <LetsGoButton
              $animateIn={animateIn}
              onClick={handleClick}
              style={{ backgroundColor: brandColor, color: letsGoButtonTextColor }}
            >
              {SignUpScreenStrings.LetsGo}
              <IconWrapper>
                <NextIcon pathFillColor={brandColor} className="icon" />
              </IconWrapper>
            </LetsGoButton>
          )}
        </NextButtonWrapper>
      </Container>
    </>
  );
};

export default LaunchScreen;
